import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const themes = {
  "dark-glass": {
    "--bg-primary": "#16181d",
    "--bg-secondary": "#1c1f26",
    "--bg-card": "rgba(46, 50, 60, 0.62)",
    "--bg-card-hover": "rgba(58, 63, 74, 0.72)",
    "--text-primary": "#ffffff",
    "--text-secondary": "rgba(255, 255, 255, 0.6)",
    "--text-tertiary": "rgba(255, 255, 255, 0.4)",
    "--accent": "#0a84ff",
    "--border-color": "rgba(255, 255, 255, 0.25   )",
    "--terminal-bg": "rgba(34, 38, 47, 0.94)",
    "--terminal-text": "#ffffff",
  },
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState("dark-glass");

  useEffect(() => {
    // Load theme from localStorage
    const savedTheme = localStorage.getItem("portfolio-theme");
    if (savedTheme && themes[savedTheme]) {
      setCurrentTheme(savedTheme);
    }
  }, []);

  useEffect(() => {
    // Apply theme CSS variables to root
    const root = document.documentElement;
    const themeVars = themes[currentTheme];

    Object.keys(themeVars).forEach((key) => {
      root.style.setProperty(key, themeVars[key]);
    });

    // Save to localStorage
    localStorage.setItem("portfolio-theme", currentTheme);
  }, [currentTheme]);

  const changeTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
